export default __webpack_public_path__ + "static/media/hero-02.1642a03c.jpg";